import { createSelector } from 'reselect';
import * as LoadingStatus from '@dragonfruit/constants/loadingState';

const typePrefix = action => `DELETE_ACCOUNT/${action}`;

export const types = {
  GET_DELETE_ACCOUNT_REASON_REQUEST: typePrefix('GET_REASON_REQUEST'),
  GET_DELETE_ACCOUNT_REASON_SUCCESS: typePrefix('GET_REASON_SUCCESS'),
  GET_DELETE_ACCOUNT_REASON_FAILURE: typePrefix('GET_REASON_FAILURE'),

  DELETE_ACCOUNT_REQUEST: typePrefix('DELETE_ACCOUNT_REQUEST'),
  DELETE_ACCOUNT_SUCCESS: typePrefix('DELETE_ACCOUNT_SUCCESS'),
  DELETE_ACCOUNT_FAILURE: typePrefix('DELETE_ACCOUNT_FAILURE'),

  SELECT_REASON: typePrefix('SELECT_REASON'),
  SELECT_DETAIL: typePrefix('SELECT_DETAIL'),
  SUBMIT_DELETE_REASON: typePrefix('SUBMIT_DELETE_REASON'),

  RESET: typePrefix('RESET'),
};

export const actions = {
  getDeleteAccountReason: () => ({
    type: types.GET_DELETE_ACCOUNT_REASON_REQUEST,
  }),
  getDeleteAccountReasonSuccess: ({ reasons }) => ({
    type: types.GET_DELETE_ACCOUNT_REASON_SUCCESS,
    reasons,
  }),
  getDeleteAccountReasonFailure: () => ({
    type: types.GET_DELETE_ACCOUNT_REASON_FAILURE,
  }),
  deleteAccount: password => ({
    type: types.DELETE_ACCOUNT_REQUEST,
    password,
  }),
  deleteAccountSuccess: () => ({
    type: types.DELETE_ACCOUNT_SUCCESS,
  }),
  deleteAccountFailure: () => ({
    type: types.DELETE_ACCOUNT_FAILURE,
  }),
  selectReason: id => ({
    type: types.SELECT_REASON,
    reasonId: id,
  }),
  selectDetail: id => ({
    type: types.SELECT_DETAIL,
    detailId: id,
  }),
  submitDeleteReason: userReason => ({
    type: types.SUBMIT_DELETE_REASON,
    userReason,
  }),
  reset: () => ({
    type: types.RESET,
  }),
};

const initialState = {
  uploadStatus: LoadingStatus.EMPTY,
  reasons: [],
  reasonId: 0,
  detailId: 0,
  userReason: '',
};

/*eslint-disable complexity */
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_DELETE_ACCOUNT_REASON_REQUEST:
      return {
        ...state,
        uploadStatus: LoadingStatus.LOADING,
      };
    case types.GET_DELETE_ACCOUNT_REASON_SUCCESS:
      return {
        ...state,
        uploadStatus: LoadingStatus.READY,
        reasons: action.reasons,
      };
    case types.GET_DELETE_ACCOUNT_REASON_FAILURE:
      return {
        ...state,
        uploadStatus: LoadingStatus.ERROR,
      };
    case types.DELETE_ACCOUNT_REQUEST:
      return {
        ...state,
        uploadStatus: LoadingStatus.LOADING,
      };
    case types.DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        uploadStatus: LoadingStatus.READY,
      };
    case types.DELETE_ACCOUNT_FAILURE:
      return {
        ...state,
        uploadStatus: LoadingStatus.ERROR,
      };
    case types.SELECT_REASON:
      return {
        ...state,
        reasonId: action.reasonId,
      };
    case types.SELECT_DETAIL:
      return {
        ...state,
        detailId: action.detailId,
      };
    case types.SUBMIT_DELETE_REASON:
      return {
        ...state,
        userReason: action.userReason,
      };
    case types.RESET:
      return initialState;
    default:
      return state;
  }
};

export default reducer;

export const getDeleteAccountReasons = state => state.deleteAccount.reasons;
export const getDeleteAccountReasonId = state => state.deleteAccount.reasonId;
export const getDeleteAccountDetailId = state => state.deleteAccount.detailId;
export const getSelectedReason = createSelector(
  getDeleteAccountReasons,
  getDeleteAccountReasonId,
  (deleteAccountReasons, reasonId) =>
    deleteAccountReasons.filter(r => r.id === reasonId)[0] || {}
);
export const getReasonDetails = createSelector(
  getSelectedReason,
  reason => reason.deleteAccountReasonDetails || []
);
export const getUserReason = state => state.deleteAccount.userReason;



// WEBPACK FOOTER //
// ./app/redux/deleteAccount.js